import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2, 0, 4),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
      marginBottom: '60px',
    },
  },
  tabContent: {
    margin: '0 auto',
    width: '100%',
    boxSizing: 'border-box',
    padding: theme.spacing(2, 3, 0),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.5, 2, 0),
    },
  },
  emptyStateContent: {
    padding: theme.spacing(4, 2),
  },
  groupEventsWrapper: {
    marginTop: 0,
    [theme.breakpoints.down('xs')]: {
      marginBottom: theme.spacing(8),
    },
  },
  tipBannerWrapper: {
    maxWidth: 832,
    margin: theme.spacing(0, 'auto', 3),
    width: '100%',
    boxSizing: 'border-box',
    padding: theme.spacing(2, 3, 0),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.5, 2, 0),
      marginBottom: theme.spacing(2.5),
    },
  },
  disabledActionTile: {
    backgroundColor: theme.palette.grey[200],
  },
}))
